/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import Vue from 'vue';

function mixins() {
  for (var _len = arguments.length, mixins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    mixins2[_key] = arguments[_key];
  }
  return Vue.extend({
    mixins: mixins2
  });
}

export { mixins as default };
//# sourceMappingURL=mixins.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/utils/mixins.js
// module id = null
// module chunks = 